import { render, staticRenderFns } from "./responsive-apply-reset-actions.vue?vue&type=template&id=6b560152&scoped=true&"
import script from "./responsive-apply-reset-actions.vue?vue&type=script&lang=js&"
export * from "./responsive-apply-reset-actions.vue?vue&type=script&lang=js&"
import style0 from "./responsive-apply-reset-actions.vue?vue&type=style&index=0&id=6b560152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b560152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b560152')) {
      api.createRecord('6b560152', component.options)
    } else {
      api.reload('6b560152', component.options)
    }
    module.hot.accept("./responsive-apply-reset-actions.vue?vue&type=template&id=6b560152&scoped=true&", function () {
      api.rerender('6b560152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/responsive-apply-reset-actions.vue"
export default component.exports